export default __webpack_public_path__ + "static/media/image-money-bag.86c3fd0f.svg";